export const NOTIFICATION_CHANNELS = ['email', 'sms'] as const;

export type NotificationChannel = (typeof NOTIFICATION_CHANNELS)[number];

export function isNotificationChannel(
  value: string
): value is NotificationChannel {
  return (NOTIFICATION_CHANNELS as readonly string[]).includes(value);
}

export type DerivedNotificationRow = {
  notificationTemplateId: string;
  channel: NotificationChannel;
};

export type MatrixCellId = {
  notificationTemplateId: string;
  channel: NotificationChannel;
  locale: string;
};
